const language = {
  zhCn: {
    onlineSearch: "联网搜索",
  },
  en: {
    onlineSearch: "Internet",
  },
};

export const getLang = (locale: string) => {
  const result = language[(locale as keyof typeof language) || "en"];
  if (!result) {
    return language.en;
  }
  return result;
};
